import { FlashMessagePosition } from './flash-messages.types';

export const DEFAULT_MESSAGE_DURATION: number = 6000;
export const DEFAULT_MESSAGE_POSITION: FlashMessagePosition = {
	vertical: 'bottom',
	horizontal: 'right',
};
